import { IProject, IUserToken } from "@/interfaces";

export const calculateIsUserProjectLeader = (
  projectLoading: boolean,
  project: IProject,
  { user: { id } }: IUserToken
): boolean => {
  if (projectLoading || !project || !id) return false;

  return (
    (!!project.projectLeaders &&
      Object.values(project.projectLeaders).includes(id)) ||
    project.backupProjectLeader === id
  );
};
